  <img
    *ngIf="!showFallback && imageUrl"
    [src]="imageUrl"
    (error)="handleImageError()"
    alt="Immagine caricata da S3"
    class="img-fluid rounded shadow-sm"
    style="max-height: 400px;"
  />

  <img
    *ngIf="showFallback"
    [src]="fallbackUrl"
    alt="Immagine non disponibile"
    class="img-fluid rounded shadow-sm opacity-50"
    style="max-height: 400px;"
  />
